module.exports = __webpack_public_path__ + "static/media/erin_walerko_portrait.05fe3898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/erin_walerko_portrait.jpg
// module id = 597
// module chunks = 0